export default __webpack_public_path__ + "static/media/img-1.3c3a56e7.jpg";